import React, {Component} from 'react';
import {Switch, Route} from 'react-router-dom';
import {connect} from 'react-redux';
import {loginFetchData} from "./login/LoginAction";
import {ConnectedRouter} from 'react-router-redux';
import {history} from './store/configureStore';
import OverviewScreen from "./overview/OverviewScreen";
import LevelScreen from "./level/LevelScreen";
import WorkoutScreen from "./workout/WorkoutScreen";
import FriendsScreen from "./friends/FriendsScreen";
import SurveyScreen from "./survey/SurveyScreen";
import DisabledScreen from "./disabled/DisabledScreen";
import RatingScreen from "./rating/RatingScreen";
import SuccessScreen from "./success/SuccessScreen";
import InviteScreen from "./invite/InviteScreen";
import PayoutScreen from "./payout/PayoutScreen";
import PayoutSuccessScreen from "./success/PayoutSuccessScreen";
import PauseScreen from "./pause/PauseScreen";
import InfoScreen from "./info/InfoScreen";
import WorkoutPreview from './workoutPreview/workoutPreview';
import MilestoneScreen from './milestone/MilestoneScreen';
import UpgradeScreen from "./upgrade/UpgradeScreen";
import LoginScreen from "./login/LoginScreen";

class UnauthorizedScreen extends Component {
    render() {
        return (
            <ConnectedRouter history={history}>
                <div style={{width: '100%'}}>
                    <Switch>
                        <Route exact path="/:email/:accesshash" component={LoginScreen}/>
                        <Route component={LoginScreen}/>
                    </Switch>
                </div>
            </ConnectedRouter>

        );
    }
}

const mapStateToProps = (state) => {
    return {
        isLoggedIn: state.auth.isLoggedIn,
        //loadingLoginFailed: state.loadingLoginFailed,
        //isLoading: state.loginIsLoading
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchData: (email, password) => dispatch(loginFetchData(email, password))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UnauthorizedScreen);




// WEBPACK FOOTER //
// ./src/UnauthorizedScreen.js